import { useEntitiesServiceEntitiesColorsListKey } from '@insurance/api/queries'
import { EntitiesService } from '@insurance/api/requests'
import { InfiniteAutoComplete } from '@shared/components'
import { capitalize } from '@shared/utils'
import { AutoCompleteProps } from 'antd'

type Props = {} & AutoCompleteProps

export const ColorAutoComplete = ({ ...props }: Props) => {
  return (
    <InfiniteAutoComplete
      apiCall={({ search, pageParam, pageSize }) =>
        EntitiesService.entitiesColorsList(
          undefined,
          pageParam,
          pageSize,
          search
        )
      }
      queryKey={[useEntitiesServiceEntitiesColorsListKey]}
      getOption={({ name }) => ({ value: capitalize(name) })}
      {...props}
    />
  )
}
